import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4fd667aa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4fd667aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd667aa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Cta: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/Cta.vue').default})
